import {Iterable, fromJS} from 'immutable';

export default class Metadata {
  constructor({path, registeredClassName, checksum, lastModifiedAt, createdAt, contentType}) {
    this.path = path;
    this.registeredClassName = registeredClassName;
    this.checksum = checksum;
    this.contentType = contentType;

    if ( lastModifiedAt && !(lastModifiedAt instanceof Date) )  {
      throw new Error(`lastModifiedAt must be a Date, given ${lastModifiedAt}`);
    }
    this.lastModifiedAt = lastModifiedAt;
    if ( createdAt && !(createdAt instanceof Date) )  {
      throw new Error(`createdAt must be a Date, given ${createdAt}`);
    }
    this.createdAt = createdAt;

  }
  static fromStorableData (data) {
    if (!Array.isArray(data) && data.constructor !== Object ) {
      throw new Error(`Expected plain JS objects, but got ${data} (a type of ${data.constructor}`);
    }
  }
  withPath (path) {
    if (this.path) {
      if (this.path === path) {
        return this;
      }
      throw new Error(`Metadata object already had a path!`);
    }
    return new this.constructor({path,
      registeredClassName: this.registeredClassName,
      checksum: this.checksum,
      lastModifiedAt: this.lastModifiedAt,
      createdAt: this.createdAt
    });
  }
  withTimestamps (createdAt, lastModifiedAt) {
    if (this.createdAt || this.lastModifiedAt) {
      if (this.createdAt === createdAt && this.lastModifiedAt === lastModifiedAt) {
        return this;
      }
      throw new Error(`Metadata object already has timestamps!`);
    }
    return new this.constructor({
      path: this.path,
      registeredClassName: this.registeredClassName,
      checksum: this.checksum,
      lastModifiedAt: lastModifiedAt,
      createdAt: createdAt
    });
  }
  toStorableData (...onlyKeys) {
    let keys;
    if (onlyKeys.length === 0) {
      keys = new Set(['path', 'checksum', 'registeredClassName', 'createdAt', 'lastModifiedAt']);
    } else {
      keys = new Set(onlyKeys);
    }
    let data = {}
    if (keys.has('path')) {
      data.path = this.path;
    }
    if (keys.has('checksum')) {
      data.checksum = this.checksum;
    }
    if (keys.has('registeredClassName')) {
      data.registeredClassName = this.registeredClassName;
    }
    if (keys.has('createdAt')) {
      data.createdAt = this.createdAt.toJSON();
    }
    if (keys.has('lastModifiedAt')) {
      data.lastModifiedAt = this.lastModifiedAt.toJSON();
    }
    return data;

  }
  static fromImmutable (data) {
    if (!Iterable.isIterable(data)) {
      throw new Error(`Expected immutable data, given ${data}`);
    }
  }

  toImmutable (...onlyKeys) {
    return fromJS(this.toStorableData(...onlyKeys));
  }
  toString () {
    return `${this.constructor.name}({path: ${this.path}, registeredClassName: ${this.registeredClassName}, checksum: ${this.checksum}, createdAt: ${this.createdAt}, lastModifiedAt: ${this.lastModifiedAt}})`;
  }
  inspect () {
    return this.toString();
  }

  get isMetadata() {
    return true;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-repos/meta.js